import { MenuItem } from "@app/types/common.type";
import { MdDeviceUnknown } from "react-icons/md";
import { FaUnlink } from "react-icons/fa";
import { IoIosHome } from "react-icons/io";

// import { SlCallOut, SlCallIn } from "react-icons/sl";

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DEFAULT_MINUTES_SECONDS_FORMAT = "mm:ss";

export const DEFAULT_PAGE = 1;
export const DEFAULT_TOTAL_PAGES = 1;

export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
export const USER_INFO_KEY = "user_info";

export enum OrderType {
  ASC = "ASC",
  DESC = "DESC",
}

export enum Role {
  ADMIN = "admin",
  USER = "user",
  COMPANY = "company",
}

export enum PathnameUrl {
  DEVICE_MANAGEMENT = "/device-management",
  LINK_MANAGEMENT = "/links-management",
  COMPANY_MANAGEMENT = "/company-management",
  STATISTICAL_MANAGEMENT = "/statistical-management",
  CALL_MANAGEMENT = "/call-management",
  ANSWER_MANAGEMENT = "/answer-management",
  LOGIN = "/login",
  CHANGE_PASSWORD = "/change-password",
}

export enum LabelAdmin {
  DEVICE_MANAGEMENT = "Thiết bị",
  LINK_MANAGEMENT = "Link Download",
  COMPANY_MANAGEMENT = "Công ty",
  STATISTICAL_MANAGEMENT = "Thống Kê",
  CHANGE_PASSWORD = "Đổi mật khẩu",
  // CALL_MANAGEMENT = "Thiết Bị Call",
  // ANSWER_MANAGEMENT = "Thiết Bị Answer",
}

export const Menu: readonly MenuItem[] = [
  {
    linkTo: PathnameUrl.DEVICE_MANAGEMENT,
    icon: MdDeviceUnknown,
    label: LabelAdmin.DEVICE_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.LINK_MANAGEMENT,
    icon: FaUnlink,
    label: LabelAdmin.LINK_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.COMPANY_MANAGEMENT,
    icon: IoIosHome,
    label: LabelAdmin.COMPANY_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.CHANGE_PASSWORD,
    icon: IoIosHome,
    label: LabelAdmin.CHANGE_PASSWORD,
  },
  // {
  //   linkTo: PathnameUrl.CALL_MANAGEMENT,
  //   icon: SlCallOut,
  //   label: LabelAdmin.CALL_MANAGEMENT,
  // },
  // {
  //   linkTo: PathnameUrl.ANSWER_MANAGEMENT,
  //   icon: SlCallIn,
  //   label: LabelAdmin.ANSWER_MANAGEMENT,
  // },
];

export const MenuCompany: readonly MenuItem[] = [
  {
    linkTo: PathnameUrl.DEVICE_MANAGEMENT,
    icon: MdDeviceUnknown,
    label: LabelAdmin.DEVICE_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.CHANGE_PASSWORD,
    icon: IoIosHome,
    label: LabelAdmin.CHANGE_PASSWORD,
  },
  // {
  //   linkTo: PathnameUrl.LINK_MANAGEMENT,
  //   icon: FaUnlink,
  //   label: LabelAdmin.LINK_MANAGEMENT,
  // },
  // {
  //   linkTo: PathnameUrl.CALL_MANAGEMENT,
  //   icon: SlCallOut,
  //   label: LabelAdmin.CALL_MANAGEMENT,
  // },
  // {
  //   linkTo: PathnameUrl.ANSWER_MANAGEMENT,
  //   icon: SlCallIn,
  //   label: LabelAdmin.ANSWER_MANAGEMENT,
  // },
];
